import {
  Component,
  ElementRef,
  inject,
  isDevMode,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { IxExceptionMessage } from 'ix-ng-forms';
import { IxAutoCompleteComponent, IxNgComponentsModule } from 'ix-ng-components';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { IxExceptionMessageEnvironmentDescription } from './ix-exception-message-environment.enum';
import { Maybe } from 'ix-ng-static-utils';
import { ErrorReportingData } from '../services/base-app.service';
import { ComVizitkaDTO } from '../vizitka/vizitka.model';
import { VizitkaService } from '../vizitka/vizitka.service';

@Component({
  selector: 'lib-error-reporting-dialog',
  templateUrl: './error-reporting-dialog.component.html',
  styleUrls: ['./errorReportingDialog.component.css'],
  encapsulation: ViewEncapsulation.None,
  imports: [IxNgComponentsModule],
})
export class ErrorReportingDialogComponent {
  public CLIENT = IxExceptionMessageEnvironmentDescription.client.key;
  public SERVER = IxExceptionMessageEnvironmentDescription.server.key;

  public errorList: IxExceptionMessage[] = [];
  public reportSectionVisible = false;
  public reportLink: string | undefined = undefined;

  public ref = inject(DynamicDialogRef);
  public config = inject(DynamicDialogConfig);
  public vizitkaService = inject(VizitkaService);

  @ViewChild('autoCompleteComponent')
  public autocomplete?: IxAutoCompleteComponent;
  @ViewChild('btnSubmit')
  public btnSubmit?: ElementRef<HTMLButtonElement>;

  get comVizitkaDTO(): Maybe<ComVizitkaDTO> {
    return this.vizitkaService?.data?.row;
  }

  constructor() {
    const data: ErrorReportingData = this.config.data;
    this.errorList = data.errorList;
    this.errorList = this.errorList.map((r) => ({
      ...r,
      openDetails: r.openDetails === null && isDevMode(),
    }));
    this.reportLink = this.createReportLink();
  }

  potrdi() {
    this.ref.close();
  }

  createReportLink(): string | undefined {
    return 'mailto:';
  }
}
